import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  span {
    width: max-content;
    background: #ff9000;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden;

    position: absolute;
    bottom: calc(100% + 12px);
    left: ${props => (props.className === 'big' ? 'unset' : '40%')};

    transform: ${props =>
      props.className === 'big' ? 'none' : 'translateX(-50%)'};
    color: #312e38;

    right: ${props => (props.className === 'big' ? '40%' : 'unset')};

    &::before {
      content: '';
      border-style: solid;
      border-color: #ff9000 transparent;
      border-width: 6px 6px 0 6px;
      top: 100%;
      position: absolute;
      left: ${props => (props.className === 'big' ? 'unset' : '50%')};
      right: ${props => (props.className === 'big' ? '20px' : 'unset')};
      transform: ${props =>
        props.className === 'big' ? 'none' : ' translateX(-50%)'};
    }

    li {
      padding: 5px;
    }
  }

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;

export default Container;
